exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stackChart{display:flex;overflow:hidden;flex:1;flex-flow:column}.stackChartContent{display:flex;flex:1;border-top:1px solid var(--grey-30)}", ""]);

